import { useRouter, type Href } from 'expo-router'
import { useMemo } from 'react'
import { Platform } from 'react-native'

import { env } from '@/src/config/env'

import { useRoutes } from '../utils/routes'

export const useBackHandlePress = (fallbackRoute?: Href) => {
  const { canGoBack, back, navigate } = useRouter()
  const { routes } = useRoutes()
  const hasReferrer = document.referrer != null && document.referrer !== ''
  const handleBackPress = useMemo(
    () => () => {
      if (env.EXPO_PUBLIC_LEGACY_COMPATIBILITY && Platform.OS === 'web') {
        // history.back has also no meaning when user reach page through native app deeplink
        // We need to check if the user is coming from a widget
        // In case they are, we need to go back to prayer space
        if (document.referrer && !document.referrer.includes('widget') && !document.referrer.includes('android-app')) {
          return history.back()
        }
      }
      if (canGoBack()) {
        return back()
      } else {
        return navigate(fallbackRoute || routes['prayer-space']())
      }
    },
    [canGoBack, back, navigate, fallbackRoute, routes],
  )

  return { handleBackPress, hasReferrer }
}
